module.exports = __webpack_public_path__ + "img/search.e523b44c.svg";